import { useRef, useState } from "react";
import { toast } from "sonner";
import { Lock, PenLine, Plus, Save, X } from "lucide-react";
import { api } from "../../lib/api";
import { DocEditor } from "../DocEditor";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { fmt, errMsg } from "./legalUtils";

const Editor = ({ init, onCancel, onSave }) => {
  const ed = useRef(null);
  const [title, setTitle] = useState(init?.title || "إجراء / محضر");
  return (
    <div className="space-y-2 rounded-2xl border-2 border-amber-300 bg-amber-50/40 p-3" data-testid="legal-minute-editor">
      <Input value={title} onChange={(e) => setTitle(e.target.value)} className="h-9 bg-white" data-testid="legal-minute-title" />
      <DocEditor ref={ed} compact initialHTML={init?.body_html || ""} />
      <div className="flex gap-2">
        <Button size="sm" onClick={() => onSave(title, ed.current?.getHTML() || "")} className="gap-1 bg-[#0f1f3d]" data-testid="legal-minute-save"><Save className="h-4 w-4" /> حفظ</Button>
        <Button size="sm" variant="outline" onClick={onCancel}><X className="h-4 w-4" /> إلغاء</Button>
      </div>
    </div>
  );
};

export const LegalMinutes = ({ c, me, onChanged }) => {
  const [edit, setEdit] = useState(null);
  const save = async (title, body_html) => {
    try {
      if (edit?.id) await api.legalMinuteEdit(c.id, edit.id, { title, body_html });
      else await api.legalAct(c.id, "minutes", { title, body_html });
      toast.success("تم الحفظ"); setEdit(null); onChanged();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const mins = c.minutes || [];
  return (
    <div className="space-y-3">
      {mins.length === 0 && !edit && <p className="py-8 text-center text-sm text-slate-400">لا توجد محاضر بعد</p>}
      {mins.map((m) => edit?.id === m.id ? <Editor key={m.id} init={m} onCancel={() => setEdit(null)} onSave={save} /> : (
        <article key={m.id} className="rounded-2xl border border-slate-200 bg-white" data-testid={`legal-minute-${m.id}`}>
          <header className="flex flex-wrap items-center gap-2 border-b border-slate-100 px-4 py-2">
            <span className="rounded-full bg-[#0f1f3d] px-2 py-0.5 text-[10px] font-bold text-amber-200">المستوى {m.level + 1}</span>
            <b className="text-sm text-slate-800">{m.title}</b>
            <span className="text-[11px] text-slate-500">— {m.author} · {fmt(m.at)}</span>
            {m.locked ? <span className="ms-auto flex items-center gap-1 text-[11px] text-slate-400"><Lock className="h-3 w-3" /> مقفل</span>
              : c.can_act && m.author_id === me && <button onClick={() => setEdit(m)} className="ms-auto flex items-center gap-1 text-[11px] font-bold text-blue-600" data-testid={`legal-minute-edit-${m.id}`}><PenLine className="h-3 w-3" /> تعديل</button>}
          </header>
          <div className="prose-sm max-w-none px-4 py-3 text-[14px] leading-8 text-slate-800" dangerouslySetInnerHTML={{ __html: m.body_html }} />
        </article>
      ))}
      {edit && !edit.id && <Editor onCancel={() => setEdit(null)} onSave={save} />}
      {c.can_act && !edit && <Button variant="outline" onClick={() => setEdit({})} className="w-full gap-1.5 border-dashed" data-testid="legal-add-minute"><Plus className="h-4 w-4" /> إضافة إجراء / محضر في هذه المرحلة</Button>}
    </div>
  );
};
